import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Modal, Input, Button, Checkbox, Spin, notification, message } from "antd";
import SecondaryButton from "../../Buttons/SecondaryButton";
import CloseButton from "../../SVG/CloseButtonSVG";
import { documentuserShareList, linkDocumentApi, treeApi } from "../../../features/dataRoomSlice";
import PrimaryButton from "../../Buttons/PrimaryButton";

const LinkDocumentModal = ({ isOpen, onClose, documentList }) => {
    const [checkedItems, setCheckedItems] = useState({});
    const [fileLink, setFileLink] = useState("");
    const [modalVisible, setModalVisible] = useState(isOpen);
    const [folders, setFolders] = useState({});
    const [loading, setLoading] = useState(false);
    const [ids, setIds] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const dispatch = useDispatch();

    console.log("This is the link document", documentList)

    useEffect(() => {
        setModalVisible(isOpen);
        const fetchData = async () => {
            if (isOpen) {
                setLoading(true);
                const response = await dispatch(treeApi()).unwrap();
                processDocumentList(response.documentList);
            }
        };
        fetchData();
    }, [isOpen, dispatch]);

    const processDocumentList = (list) => {
        const folderStructure = {};

        list.forEach((doc) => {
            if (doc.type === "file") {
                const folderName = doc.path.split('/').slice(-2, -1)[0];
                if (!folderStructure[folderName]) {
                    folderStructure[folderName] = [];
                }
                folderStructure[folderName].push({
                    id: doc._id,
                    name: doc.name,
                    type: doc.type,
                    path: doc.path,
                });
            }
        });

        setFolders(folderStructure);
        setLoading(false);
    };

    const handleOk = () => {
        setModalVisible(false);
        onClose();
    };

    const handleCancel = () => {
        setModalVisible(false);
        onClose();
    };

    const handleCheckboxChange = (folder, file, isChecked, id) => {
        setCheckedItems((prevState) => ({
            ...prevState,
            [folder]: {
                ...prevState[folder],
                [file]: isChecked,
            },
        }));

        if (isChecked) {
            setIds((prevState) => [...prevState, id]);
        } else {
            setIds((prevState) => prevState.filter((existingId) => existingId !== id));
        }
    };

    const handleAddLink = async () => {
        console.log(ids)
        setIsLoading(true)
        const body = {
            documentId: documentList?._id,
            linkDocumentIdList: ids
        }
        await dispatch(linkDocumentApi(body)).then((response) => {
            if(response.meta.requestStatus === "fulfilled") {
                setIsLoading(false);
                message.success("File link added successfully")
                handleCancel()
            } else {
                setIsLoading(false);
                message.error("Failed to link file. Please try again")
            }
        })
    };

    return (
        <Modal
            title={`Select the files you wish to link to ${documentList.name}`}
            centered
            visible={modalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
                <Button key="cancel" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button key="link" type="primary" onClick={handleOk}>
                    Link
                </Button>,
            ]}
        >
            <button
                className="absolute top-4 right-3 cursor-pointer opacity-70 hover:opacity-100 transition-all"
                onClick={handleCancel}
            >
                <CloseButton />
            </button>

            <div style={{ maxHeight: "400px", overflow: "auto" }}>
                {loading ? (
                    <div className="flex justify-center items-center">
                        <div role="status">
                            <svg aria-hidden="true" class="inline w-10 h-10 text-gray-200 animate-spin fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
                            </svg>
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                ) : (
                    Object.entries(folders).map(([folder, files]) => (
                        <div key={folder} className="mb-4">
                            <div className="font-medium text-gray-900 mb-2 cursor-pointer">
                                {folder}
                            </div>
                            {files.map((file) => (
                                <div
                                    key={file.name}
                                    className="flex items-center justify-between px-8 py-2 font-normal"
                                >
                                    {file.name}
                                    <Checkbox
                                        checked={checkedItems[folder]?.[file.name] || false}
                                        onChange={(e) => handleCheckboxChange(folder, file.name, e.target.checked, file.id)}
                                    />
                                </div>
                            ))}
                        </div>
                    ))
                )}
            </div>
            <div className="flex justify-between">
                <SecondaryButton onClick={handleCancel} size="Medium" text={"Cancel"} isDisabled={isLoading}/>
                <PrimaryButton onClick={handleAddLink} size="Medium" text={"Add"} isLoading={isLoading} isDisabled={isLoading}/>
            </div>

        </Modal>
    );
};

export default LinkDocumentModal;

